"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentGuard = void 0;
var msal_react_1 = require("@azure/msal-react");
var React = require("react");
var react_1 = require("react");
var msal_browser_1 = require("@azure/msal-browser");
var authConfig_1 = require("../authConfig");
require("../styles/LoginPage.css");
var ComponentGuard = function (_a) {
    var props = __rest(_a, []);
    var authRequest = __assign({}, authConfig_1.loginRequest);
    var _b = msal_react_1.useMsal(), instance = _b.instance, inProgress = _b.inProgress;
    var _c = react_1.useState(false), isAuthorized = _c[0], setIsAuthorized = _c[1];
    var onLoad = function () {
        var currentAccount = instance.getActiveAccount();
        if (currentAccount && currentAccount.idTokenClaims) {
            var tokenClaims = currentAccount.idTokenClaims['roles'];
            var intersection = props.roles
                .filter(function (role) { return tokenClaims.includes(role); });
            if (intersection.length > 0) {
                setIsAuthorized(true);
            }
        }
    };
    react_1.useEffect(function () {
        if (inProgress === msal_browser_1.InteractionStatus.None)
            onLoad();
    }, [inProgress, instance]);
    return (React.createElement(React.Fragment, null,
        React.createElement(msal_react_1.MsalAuthenticationTemplate, { interactionType: msal_browser_1.InteractionType.Redirect, authenticationRequest: authRequest }, isAuthorized
            ?
                props.children
            :
                React.createElement(React.Fragment, null))));
};
exports.ComponentGuard = ComponentGuard;
//# sourceMappingURL=ComponentGuard.js.map